import type {NavigationTarget, ScriptSection} from "@/services/wingman";

export const SCRIPT_SECTIONS: readonly ScriptSection[] = [
   "script",
   "knowledge",
   "agent",
   "timeHours",
   "testLaunch",
];

const VALID_DIRECTIONS = new Set(["inbound", "outbound"]);

/** Conversation currently on screen: the full-page GailGPT route, otherwise the dock's. */
export function activeChatConversationId(
   pathname: string | null,
   dockConversationId: string | null
): string | null {
   const match = pathname ? /^\/gailgpt\/([^/?#]+)/.exec(pathname) : null;
   if (match?.[1]) {
      try {
         return decodeURIComponent(match[1]);
      } catch {
         return match[1];
      }
   }
   return dockConversationId;
}

export function buildScriptNavigationHref(target: NavigationTarget): string | null {
   if (!target?.direction || !VALID_DIRECTIONS.has(target.direction)) return null;

   const base = `/${target.direction}/scripts`;
   if (!target.scriptId) return base;

   const href = `${base}/${encodeURIComponent(target.scriptId)}`;
   return target.section ? `${href}?page=${encodeURIComponent(target.section)}` : href;
}
